import React, { useState } from "react";

import FormGroup from "react-bootstrap/lib/FormGroup";

import { FormControl, Button } from "react-bootstrap";
import cs from "../../commonStyle.css";
import cx from "classnames";

export default function LicencePlateInput({ callback, isDisabled }) {
  const [licencePlate, setLicencePlate] = useState();

  const handleCallback = () => {
    callback(licencePlate);
  };

  return (
    <FormGroup>
      <label>Licence Plate</label>
      <div className={cs.displayFlex}>
        <FormControl
          placeholder={"Licence plate"}
          type="text"
          onChange={(e) => {
            console.log(e);
            setLicencePlate(e.target.value);
          }}
          className={cx(cs.customFieldHeight, cs.spaceRight4)}
        />
        <Button
          disabled={isDisabled}
          onClick={handleCallback}
          className={cx(cs.btnPrimaryBorder, cs.noYPadding)}
        >
          Search
        </Button>
      </div>
    </FormGroup>
  );
}
